export const isDemoUser = (user) => {
  const value = user?.isDemo;
  return value === true || value === "true" || value === 1 || value === "1";
};
